






import { Vue, Component, Prop } from "vue-property-decorator";

import { ProjectDetails } from "@/data/models/ProjectDetails";
import { MeasurementProtocolData } from "@/data/models/MeasurementProtocolData";

@Component
export default class DocumentListComponent extends Vue {
  @Prop()
  projectDetails!: ProjectDetails;

  @Prop()
  measurementProtocolData!: MeasurementProtocolData[];

  get test() {
    return "FOO";
  }
}
